<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.cargaId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.consultaCompleta">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.cargaId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Unid. Carga
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.cargaId + ''"
            v-if="
              rowData.cargaRota !== null &&
              rowData.cargaRota.cargaRotaPedagio.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Pedágios
              <i class="fa fa-map-signs"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.cargaId + ''"
            v-if="rowData.despesaCargaCollection.length > 0"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Adiantamento
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t8' + rowData.cargaId + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.consultaCompleta"
          >
            <span class="nav-link-in">
              Vale pedagio
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.redespachos.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t9' + rowData.cargaId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Redespachos
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.erroAdiantamento != ''">
          <a
              class="nav-link"
              v-bind:href="'#t10' + rowData.cargaId + ''"
              role="tab"
              data-toggle="tab"
          >
            <span class="nav-link-in">
              Erro Adiant.
              <i class="fa fa-times-circle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.integracaoLog.length > 0">
          <a
              class="nav-link"
              v-bind:href="'#t11' + rowData.cargaId + ''"
              role="tab"
              data-toggle="tab"
          >
            <span class="nav-link-in">
              Erros integr.
              <i class="fa fa-times-circle"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.cargaId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N. Fiscal</th>
                <th style="width: 5%">Valor NF</th>
                <th style="width: 5%">Dt emissão NF</th>
                <th style="width: 5%">Dt previsão NF</th>
                <th style="width: 5%">N° CTe</th>
                <th style="width: 5%">Valor CTe</th>
                <th style="width: 5%">Dt emissão CTe</th>
                <th style="width: 5%">Processo</th>
                <th style="width: 5%">Operação</th>
                <th style="width: 5%">N° Pedido</th>
                <th style="width: 5%">Unidade Carga</th>
                <th style="width: 5%">N° carga tracking</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="rowData.cargaBipDoc.length > 0 && (rowData.status.valor != 6 && rowData.status.valor != 3)" v-for="(item, i) in rowData.cargaBipDoc">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                      :title="'Chave : ' + item.docFiscal.chave"
                    >
                      {{ item.docFiscal.numFiscal }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                      :title="'Id trn : ' + item.docFiscal.pessoaIdTrn"
                    >
                      {{ formatNumber(item.docFiscal.docFiscalVlrTotal) }}
                    </span>
                  </td>
                  <td>
                    {{ formatDate(item.docFiscal.dtEmi) }}
                  </td>
                  <td>
                    {{ formatDate(item.docFiscal.dtPrevisao) }}
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscal.cargaDoc.docCargaDoc != null && item.docFiscal.cargaDoc.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docFiscal.cargaDoc.docCargaDoc.doc.numFiscal }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscal.cargaDoc.docCargaDoc != null && item.docFiscal.cargaDoc.docCargaDoc.doc != null
                      "
                    >
                      {{ formatNumber(item.docFiscal.cargaDoc.docCargaDoc.doc.vlrPrestacao) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscal.cargaDoc.docCargaDoc != null && item.docFiscal.cargaDoc.docCargaDoc.doc != null
                      "
                    >
                      {{ formatDate(item.docFiscal.cargaDoc.docCargaDoc.doc.dtEmi) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscal.cargaDoc.docCargaDoc != null && item.docFiscal.cargaDoc.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docFiscal.cargaDoc.docCargaDoc.doc.tpProcesso }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscal.cargaDoc.docCargaDoc != null && item.docFiscal.cargaDoc.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docFiscal.cargaDoc.docCargaDoc.doc.tpOperacao }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="item.docFiscal.cargaDoc.cargaDocUnidadeCarga.length > 0"
                    >
                      {{
                        item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedido
                          .numPedido
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="item.docFiscal.cargaDoc.cargaDocUnidadeCarga.length > 0"
                    >
                      {{
                        item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.numUc
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscalTracking &&
                        rowData.tpOperacaoPrincipal.valor == 3
                      "
                    >
                      {{ item.docFiscalTracking }}
                    </span>
                    <span
                      v-if="
                        item.manifesto != null &&
                        rowData.tpOperacaoPrincipal.valor == 2
                      "
                    >
                      {{
                        item.manifesto
                          .numCargaItrack
                      }}
                    </span>
                  </td>
                  <td>
                    <a
                      @click="onDetail(item.cardocbipId)"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.cardocbipId)">
                  <td colspan="15">
                    <section class="tabs-section">
                      <ul
                        class="nav nav-tabs nav-topline nav-justified"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.cardocbipId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Partes Env.
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            v-bind:href="'#tr2' + item.cardocbipId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Ocorrências
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.cardocbipId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%"></th>
                                <th style="width: 10%">CNPJ / CPF</th>
                                <th style="width: 10%">IE</th>
                                <th style="width: 10%">Nome</th>
                                <th style="width: 10%">Município</th>
                                <th style="width: 3%">Estado</th>
                                <th style="width: 15%">Endereço</th>
                                <th style="width: 12%">Bairro</th>
                                <th style="width: 10%">CEP</th>
                                <th style="width: 10%">Email</th>
                                <th style="width: 5%">Telefone</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-primary"
                                    >Emitente</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .emiCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.emiCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.emiEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.emiEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.remEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-warning"
                                    >Remetente</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .remCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.remCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.remEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.remEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .remTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.expEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-info"
                                    >Expedidor</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .expCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.expCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.expEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.expEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .expTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.desEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-success"
                                    >Destinatário</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .desCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.desCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.desEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.desEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .desTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <span class="badge badge-secondary"
                                    >Recebedor</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .redCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.redCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.redEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.redEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .redTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.tomEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-primary"
                                    >Tomador</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .tomCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.tomCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.tomEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.tomEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr2' + item.cardocId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%">Tipo</th>
                                <th style="width: 10%">Ocorrência</th>
                                <th style="width: 10%">Data Ocorrência</th>
                                <th style="width: 10%">N ° Docmento</th>
                                <th style="width: 10%">Série</th>
                                <th style="width: 10%">Dt Emissão</th>
                                <th style="width: 10%">N ° Fiscal</th>
                                <th style="width: 10%">Série</th>
                                <th style="width: 10%">Dt Emissão</th>
                                <th style="width: 10%">Status</th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item_ocorrencia in item.docFiscal
                                .cargaOcorrencia"
                            >
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <span
                                    v-if="item_ocorrencia.docfisId !== null"
                                    class="badge badge-primary"
                                    >Documento</span
                                  >
                                  <span
                                    v-if="item_ocorrencia.pedunicarId !== null"
                                    class="badge badge-warning"
                                    >Unidade Carga</span
                                  >
                                  <span
                                    v-if="item_ocorrencia.peduncatrId !== null"
                                    class="badge badge-danger"
                                    >Trecho</span
                                  >
                                </td>
                                <td>
                                  {{ item_ocorrencia.paramOcorrencia.descr }}
                                </td>
                                <td>
                                  {{ formatDate(item_ocorrencia.dtOcorrencia) }}
                                </td>
                                <td>
                                  <span
                                    v-if="item_ocorrencia.docNumFiscal != null"
                                  >
                                    {{ item_ocorrencia.docNumFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docSerie != null">
                                    {{ item_ocorrencia.docSerie }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docDtEmi != null">
                                    {{ formatDate(item_ocorrencia.docDtEmi) }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_ocorrencia.docFiscalNumFiscal != null
                                    "
                                  >
                                    {{ item_ocorrencia.docFiscalNumFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docSerie != null">
                                    {{ item_ocorrencia.docSerie }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_ocorrencia.docFiscalDtEmi != null
                                    "
                                  >
                                    {{
                                      formatDate(item_ocorrencia.docFiscalDtEmi)
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    class="badge badge-success"
                                    v-if="item_ocorrencia.status.valor == 1"
                                    >{{ item_ocorrencia.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_ocorrencia.status.valor == 2"
                                    >{{ item_ocorrencia.status.descr }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
              
              <template v-if="rowData.cargaDoc.length > 0 && (rowData.status.valor == 6 || rowData.status.valor == 3)" v-for="(item, i) in rowData.cargaDoc">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                      :title="'Chave : ' + item.docFiscal.chave"
                    >
                      {{ item.docFiscal.numFiscal }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                      :title="'Id trn : ' + item.docFiscal.pessoaIdTrn"
                    >
                      {{ formatNumber(item.docFiscal.docFiscalVlrTotal) }}
                    </span>
                  </td>
                  <td>
                    {{ formatDate(item.docFiscal.dtEmi) }}
                  </td>
                  <td>
                    {{ formatDate(item.docFiscal.dtPrevisao) }}
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docCargaDoc != null && item.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docCargaDoc.doc.numFiscal }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docCargaDoc != null && item.docCargaDoc.doc != null
                      "
                    >
                      {{ formatNumber(item.docCargaDoc.doc.vlrPrestacao) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docCargaDoc != null && item.docCargaDoc.doc != null
                      "
                    >
                      {{ formatDate(item.docCargaDoc.doc.dtEmi) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docCargaDoc != null && item.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docCargaDoc.doc.tpProcesso }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docCargaDoc != null && item.docCargaDoc.doc != null
                      "
                    >
                      {{ item.docCargaDoc.doc.tpOperacao }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="rowData.cargaDoc[0].cargaDocUnidadeCarga.length > 0"
                    >
                      {{
                        item.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedido
                          .numPedido
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="rowData.cargaDoc[0].cargaDocUnidadeCarga.length > 0"
                    >
                      {{
                        item.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.numUc
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                        item.docFiscalTracking &&
                        rowData.tpOperacaoPrincipal.valor == 3
                      "
                    >
                      {{ item.docFiscalTracking }}
                    </span>
                    <span
                      v-if="
                        item.manifesto != null &&
                        rowData.tpOperacaoPrincipal.valor == 2
                      "
                    >
                      {{
                        item.manifesto
                          .numCargaItrack
                      }}
                    </span>
                  </td>
                  <td>
                    <a
                      @click="onDetail(item.cardocId)"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.cardocId)">
                  <td colspan="15">
                    <section class="tabs-section">
                      <ul
                        class="nav nav-tabs nav-topline nav-justified"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.cardocId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Partes Env.
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            v-bind:href="'#tr2' + item.cardocId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Ocorrências
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.cardocId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%"></th>
                                <th style="width: 10%">CNPJ / CPF</th>
                                <th style="width: 10%">IE</th>
                                <th style="width: 10%">Nome</th>
                                <th style="width: 10%">Município</th>
                                <th style="width: 3%">Estado</th>
                                <th style="width: 15%">Endereço</th>
                                <th style="width: 12%">Bairro</th>
                                <th style="width: 10%">CEP</th>
                                <th style="width: 10%">Email</th>
                                <th style="width: 5%">Telefone</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-primary"
                                    >Emitente</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .emiCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.emiCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .emiComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.emiBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.emiCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.emiEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.emiEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .emiTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.remEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-warning"
                                    >Remetente</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .remCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.remCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .remComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.remBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.remCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.remEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.remEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .remTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .remTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.expEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-info"
                                    >Expedidor</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .expCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.expCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .expComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.expBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.expCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.expEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.expEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .expTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .expTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.desEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-success"
                                    >Destinatário</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .desCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.desCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .desComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.desBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.desCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.desEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.desEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .desTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .desTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <span class="badge badge-secondary"
                                    >Recebedor</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .redCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.redCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.redBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.redCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.redEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.redEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .redTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .redTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>

                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                                v-if="
                                  item.docFiscal.docFiscalPartesEnv.tomEndereco
                                "
                              >
                                <td>
                                  <span class="badge badge-primary"
                                    >Tomador</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomCnpj != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv
                                          .tomCnpj
                                      )
                                    }}
                                  </span>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomCpf != null
                                    "
                                  >
                                    {{
                                      ajustaMascara(
                                        item.docFiscal.docFiscalPartesEnv.tomCpf
                                      )
                                    }}
                                  </span>
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomIe }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomNome
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomNomeMunicipio
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomUf }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomEndereco
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv
                                      .tomComplemento
                                  }}
                                  -
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomNumero
                                  }}
                                </td>
                                <td>
                                  {{
                                    item.docFiscal.docFiscalPartesEnv.tomBairro
                                  }}
                                </td>
                                <td>
                                  {{ item.docFiscal.docFiscalPartesEnv.tomCep }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv.tomEmail
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv.tomEmail
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomTelefone
                                    "
                                    >{{
                                      item.docFiscal.docFiscalPartesEnv
                                        .tomTelefone
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr2' + item.cardocId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%">Tipo</th>
                                <th style="width: 10%">Ocorrência</th>
                                <th style="width: 10%">Data Ocorrência</th>
                                <th style="width: 10%">N ° Docmento</th>
                                <th style="width: 10%">Série</th>
                                <th style="width: 10%">Dt Emissão</th>
                                <th style="width: 10%">N ° Fiscal</th>
                                <th style="width: 10%">Série</th>
                                <th style="width: 10%">Dt Emissão</th>
                                <th style="width: 10%">Status</th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item_ocorrencia in item.docFiscal
                                .cargaOcorrencia"
                            >
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <span
                                    v-if="item_ocorrencia.docfisId !== null"
                                    class="badge badge-primary"
                                    >Documento</span
                                  >
                                  <span
                                    v-if="item_ocorrencia.pedunicarId !== null"
                                    class="badge badge-warning"
                                    >Unidade Carga</span
                                  >
                                  <span
                                    v-if="item_ocorrencia.peduncatrId !== null"
                                    class="badge badge-danger"
                                    >Trecho</span
                                  >
                                </td>
                                <td>
                                  {{ item_ocorrencia.paramOcorrencia.descr }}
                                </td>
                                <td>
                                  {{ formatDate(item_ocorrencia.dtOcorrencia) }}
                                </td>
                                <td>
                                  <span
                                    v-if="item_ocorrencia.docNumFiscal != null"
                                  >
                                    {{ item_ocorrencia.docNumFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docSerie != null">
                                    {{ item_ocorrencia.docSerie }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docDtEmi != null">
                                    {{ formatDate(item_ocorrencia.docDtEmi) }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_ocorrencia.docFiscalNumFiscal != null
                                    "
                                  >
                                    {{ item_ocorrencia.docFiscalNumFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="item_ocorrencia.docSerie != null">
                                    {{ item_ocorrencia.docSerie }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_ocorrencia.docFiscalDtEmi != null
                                    "
                                  >
                                    {{
                                      formatDate(item_ocorrencia.docFiscalDtEmi)
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    class="badge badge-success"
                                    v-if="item_ocorrencia.status.valor == 1"
                                    >{{ item_ocorrencia.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_ocorrencia.status.valor == 2"
                                    >{{ item_ocorrencia.status.descr }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.cargaId + ''"
          v-if="rowData.consultaCompleta"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Unidade Carga</th>
                <th style="width: 30%">Status</th>
                <th style="width: 40%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="rowData.cargaBipDoc.length > 0 && (rowData.status.valor != 6 && rowData.status.valor != 3)" v-for="item in rowData.cargaBipDoc">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.numUc }}
                  </td>
                  <td>
                    {{ item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.status.descr }}
                  </td>
                  <td>
                    <a
                      @click="onDetailUnidadeCargaTrecho(item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedunicarId)"
                      v-if="item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedidoUnidadeCargaTrecho.length > 0"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                    <a
                      @click="onVinculaTrecho(item)"
                      v-b-tooltip
                      title="Adicionar Trecho"
                      ><i class="fa fa-map-marker"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRowTrecho(item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedunicarId)">
                  <td colspan="9">
                    <section class="tabs-section">
                      <ul
                        class="nav nav-tabs nav-topline nav-justified"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedunicarId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Trechos
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedunicarId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%">Nº Trecho</th>
                                <th style="width: 5%">Ordem/Principal</th>
                                <th style="width: 5%">Tipo Trecho</th>
                                <th style="width: 10%">Tipo Custo</th>
                                <th style="width: 15%">Modal</th>
                                <th style="width: 13%">Município Início</th>
                                <th style="width: 12%">Municipio Fim</th>
                                <th style="width: 15%">Fornecedor</th>
                                <th style="width: 5%">Status</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item_trecho in item.docFiscal.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedidoUnidadeCargaTrecho"
                            >
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  {{ item_trecho.numTrecho }}
                                </td>
                                <td>
                                  {{ item_trecho.ordem }} -
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.principal.valor == 1"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.principal.valor == 2"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.tpTrecho.descr }}
                                </td>
                                <td>
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.tpCusto.valor == 1"
                                    >{{ item_trecho.tpCusto.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.tpCusto.valor == 2"
                                    >{{ item_trecho.tpCusto.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.bModal.descr }}
                                </td>
                                <td>
                                  {{ item_trecho.municipioIni.nome }} -
                                  {{ item_trecho.municipioIni.uf.cd }}
                                </td>
                                <td>
                                  {{ item_trecho.municipioFim.nome }} -
                                  {{ item_trecho.municipioFim.uf.cd }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaJuridica !==
                                        null
                                    "
                                    >{{
                                      onFormataCnpj(
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjBase,
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjFilial,
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjDigito
                                      )
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaJuridica
                                        .razao_social
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaFisica !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoaFisica.nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaFisica.cpf
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaExterior !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoaExterior.nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaExterior.cuit
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    class="badge badge-dark"
                                    v-if="item_trecho.status.valor == 1"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-info"
                                    v-if="item_trecho.status.valor == 2"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-warning"
                                    v-if="item_trecho.status.valor == 3"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.status.valor == 4"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.status.valor == 5"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                </td>
                                <td>
                                  <a
                                    @click="onAlteraFornecedor(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.update'
                                      ) ||
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Fornecedor"
                                    ><i class="fa fa-user"></i
                                  ></a>
                                  <a
                                    @click="onAlteraStatus(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.status'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Status"
                                    ><i class="fa fa-cogs"></i
                                  ></a>
                                  <a
                                    @click="onVinculaCusto(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Vincular Custo"
                                    ><i class="fa fa-tasks"></i
                                  ></a>
                                  <a
                                    @click="onPrintMinuta(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      ) && rowData.isTpCalcAvulsoViagem == false
                                    "
                                    v-b-tooltip
                                    title="Imprimir Minuta"
                                  >
                                    <i class="fa fa-print"></i
                                  ></a>
                                  <a
                                    @click="onVinculaOcorrencia(item_trecho, 3)"
                                    v-b-tooltip
                                    title="Vincular Ocorrência"
                                    ><i class="fa fa-exclamation-triangle"></i
                                  ></a>
                                  <a
                                    @click="onEditTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Trecho"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                  <a
                                    @click="onCalcularTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      ) &&
                                      item_trecho.fornecedor.tpFornecedor != 2
                                    "
                                    v-b-tooltip
                                    title="Calcular Trecho"
                                    ><i class="fa fa-calculator"></i
                                  ></a>
                                  <a
                                    @click="
                                      onDetailUnidadeCargaTrechoCusto(
                                        item_trecho.peduncatrId
                                      )
                                    "
                                    v-if="
                                      item_trecho.PedidoUnidadeCargaTreCusto
                                        .length > 0
                                    "
                                    v-b-tooltip
                                    title="Ver detalhes"
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                  <a
                                    @click="
                                      viewTabelaFrete(
                                        item_trecho.tabfrerotvigId
                                      )
                                    "
                                    v-b-tooltip
                                    title="Informações da Tabela de frete"
                                    ><i class="fa fa-info"></i
                                  ></a>
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  isVisibleDetailRowTrechoCusto(
                                    item_trecho.peduncatrId
                                  )
                                "
                              >
                                <td colspan="10">
                                  <section class="tabs-section">
                                    <ul
                                      class="
                                        nav nav-tabs nav-topline nav-justified
                                      "
                                      role="tablist"
                                    >
                                      <li class="nav-item">
                                        <a
                                          class="nav-link active"
                                          v-bind:href="
                                            '#trc1' +
                                            item_trecho.peduncatrId +
                                            ''
                                          "
                                          role="tab"
                                          data-toggle="tab"
                                        >
                                          <span class="nav-link-in">
                                            Custos
                                            <i class="fa fa-money"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                    <div class="tab-content">
                                      <div
                                        role="tabpanel"
                                        class="
                                          tab-pane
                                          fade
                                          in
                                          active
                                          show
                                          pt-1
                                          border-color-detalhes-grey
                                        "
                                        v-bind:id="
                                          'trc1' + item_trecho.peduncatrId + ''
                                        "
                                      >
                                        <table
                                          :class="[
                                            'vuetable table table-striped tbl-typical',
                                          ]"
                                        >
                                          <thead>
                                            <tr>
                                              <th style="width: 30%">
                                                Nº Custo
                                              </th>
                                              <th style="width: 30%">
                                                Descrição
                                              </th>
                                              <th style="width: 10%">
                                                Tipo Custo
                                              </th>
                                              <th style="width: 10%">Custo</th>
                                              <th style="width: 10%">Valor</th>
                                              <th style="width: 5%">Status</th>
                                              <!-- <th style="width: 5%">Ações</th> -->
                                            </tr>
                                          </thead>
                                          <tbody
                                            v-for="item_tre_custo in item_trecho.PedidoUnidadeCargaTreCusto"
                                          >
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                            >
                                              <td>
                                                {{ item_tre_custo.numCusto }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.descr }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.tp_custo }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.custo }}
                                              </td>
                                              <td>
                                                {{
                                                  formatNumber(
                                                    item_tre_custo.vlrCusto
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                <span
                                                  class="badge badge-success"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 1
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                                <span
                                                  class="badge badge-danger"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 2
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                              </td>
                                              <!-- <td>
                                                <a
                                                  @click="
                                                    onEditCusto(item_tre_custo)
                                                  "
                                                  v-if="
                                                    getPermissionFw(
                                                      'gerenciamentotransporte.custo.update'
                                                    )
                                                  "
                                                  v-b-tooltip
                                                  title="Alterar Custo"
                                                  ><i class="fa fa-edit"></i
                                                ></a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </section>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>

              <template v-if="rowData.cargaDoc.length > 0 && (rowData.status.valor == 6 || rowData.status.valor == 3)" v-for="item in rowData.cargaUnidadeCarga">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ item.numUc }}
                  </td>
                  <td>
                    {{ item.status.descr }}
                  </td>
                  <td>
                    <a
                      @click="onDetailUnidadeCargaTrecho(item.pedunicarId)"
                      v-if="item.pedidoUnidadeCargaTrecho.length > 0"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                    <a
                      @click="onVinculaTrecho(item)"
                      v-b-tooltip
                      title="Adicionar Trecho"
                      ><i class="fa fa-map-marker"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRowTrecho(item.pedunicarId)">
                  <td colspan="9">
                    <section class="tabs-section">
                      <ul
                        class="nav nav-tabs nav-topline nav-justified"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.pedunicarId + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Trechos
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.pedunicarId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%">Nº Trecho</th>
                                <th style="width: 5%">Ordem/Principal</th>
                                <th style="width: 5%">Tipo Trecho</th>
                                <th style="width: 10%">Tipo Custo</th>
                                <th style="width: 15%">Modal</th>
                                <th style="width: 13%">Município Início</th>
                                <th style="width: 12%">Municipio Fim</th>
                                <th style="width: 15%">Fornecedor</th>
                                <th style="width: 5%">Status</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item_trecho in item.pedidoUnidadeCargaTrecho"
                            >
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  {{ item_trecho.numTrecho }}
                                </td>
                                <td>
                                  {{ item_trecho.ordem }} -
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.principal.valor == 1"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.principal.valor == 2"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.tpTrecho.descr }}
                                </td>
                                <td>
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.tpCusto.valor == 1"
                                    >{{ item_trecho.tpCusto.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.tpCusto.valor == 2"
                                    >{{ item_trecho.tpCusto.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.bModal.descr }}
                                </td>
                                <td>
                                  {{ item_trecho.municipioIni.nome }} -
                                  {{ item_trecho.municipioIni.uf.cd }}
                                </td>
                                <td>
                                  {{ item_trecho.municipioFim.nome }} -
                                  {{ item_trecho.municipioFim.uf.cd }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaJuridica !==
                                        null
                                    "
                                    >{{
                                      onFormataCnpj(
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjBase,
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjFilial,
                                        item_trecho.fornecedor.pessoaJuridica
                                          .cnpjDigito
                                      )
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaJuridica
                                        .razao_social
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaFisica !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoaFisica.nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaFisica.cpf
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoaExterior !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoaExterior.nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoaExterior.cuit
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    class="badge badge-dark"
                                    v-if="item_trecho.status.valor == 1"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-info"
                                    v-if="item_trecho.status.valor == 2"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-warning"
                                    v-if="item_trecho.status.valor == 3"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.status.valor == 4"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.status.valor == 5"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                </td>
                                <td>
                                  <a
                                    @click="onAlteraFornecedor(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.update'
                                      ) ||
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Fornecedor"
                                    ><i class="fa fa-user"></i
                                  ></a>
                                  <a
                                    @click="onAlteraStatus(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.status'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Status"
                                    ><i class="fa fa-cogs"></i
                                  ></a>
                                  <a
                                    @click="onVinculaCusto(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Vincular Custo"
                                    ><i class="fa fa-tasks"></i
                                  ></a>
                                  <a
                                    @click="onPrintMinuta(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      ) && rowData.isTpCalcAvulsoViagem == false
                                    "
                                    v-b-tooltip
                                    title="Imprimir Minuta"
                                  >
                                    <i class="fa fa-print"></i
                                  ></a>
                                  <a
                                    @click="onVinculaOcorrencia(item_trecho, 3)"
                                    v-b-tooltip
                                    title="Vincular Ocorrência"
                                    ><i class="fa fa-exclamation-triangle"></i
                                  ></a>
                                  <a
                                    @click="onEditTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Trecho"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                  <a
                                    @click="onCalcularTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      ) &&
                                      item_trecho.fornecedor.tpFornecedor != 2
                                    "
                                    v-b-tooltip
                                    title="Calcular Trecho"
                                    ><i class="fa fa-calculator"></i
                                  ></a>
                                  <a
                                    @click="
                                      onDetailUnidadeCargaTrechoCusto(
                                        item_trecho.peduncatrId
                                      )
                                    "
                                    v-if="
                                      item_trecho.PedidoUnidadeCargaTreCusto
                                        .length > 0
                                    "
                                    v-b-tooltip
                                    title="Ver detalhes"
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                  <a
                                    @click="
                                      viewTabelaFrete(
                                        item_trecho.tabfrerotvigId
                                      )
                                    "
                                    v-b-tooltip
                                    title="Informações da Tabela de frete"
                                    ><i class="fa fa-info"></i
                                  ></a>
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  isVisibleDetailRowTrechoCusto(
                                    item_trecho.peduncatrId
                                  )
                                "
                              >
                                <td colspan="10">
                                  <section class="tabs-section">
                                    <ul
                                      class="
                                        nav nav-tabs nav-topline nav-justified
                                      "
                                      role="tablist"
                                    >
                                      <li class="nav-item">
                                        <a
                                          class="nav-link active"
                                          v-bind:href="
                                            '#trc1' +
                                            item_trecho.peduncatrId +
                                            ''
                                          "
                                          role="tab"
                                          data-toggle="tab"
                                        >
                                          <span class="nav-link-in">
                                            Custos
                                            <i class="fa fa-money"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                    <div class="tab-content">
                                      <div
                                        role="tabpanel"
                                        class="
                                          tab-pane
                                          fade
                                          in
                                          active
                                          show
                                          pt-1
                                          border-color-detalhes-grey
                                        "
                                        v-bind:id="
                                          'trc1' + item_trecho.peduncatrId + ''
                                        "
                                      >
                                        <table
                                          :class="[
                                            'vuetable table table-striped tbl-typical',
                                          ]"
                                        >
                                          <thead>
                                            <tr>
                                              <th style="width: 30%">
                                                Nº Custo
                                              </th>
                                              <th style="width: 30%">
                                                Descrição
                                              </th>
                                              <th style="width: 10%">
                                                Tipo Custo
                                              </th>
                                              <th style="width: 10%">Custo</th>
                                              <th style="width: 10%">Valor</th>
                                              <th style="width: 5%">Status</th>
                                              <!-- <th style="width: 5%">Ações</th> -->
                                            </tr>
                                          </thead>
                                          <tbody
                                            v-for="item_tre_custo in item_trecho.PedidoUnidadeCargaTreCusto"
                                          >
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                            >
                                              <td>
                                                {{ item_tre_custo.numCusto }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.descr }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.tp_custo }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.custo }}
                                              </td>
                                              <td>
                                                {{
                                                  formatNumber(
                                                    item_tre_custo.vlrCusto
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                <span
                                                  class="badge badge-success"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 1
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                                <span
                                                  class="badge badge-danger"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 2
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                              </td>
                                              <!-- <td>
                                                <a
                                                  @click="
                                                    onEditCusto(item_tre_custo)
                                                  "
                                                  v-if="
                                                    getPermissionFw(
                                                      'gerenciamentotransporte.custo.update'
                                                    )
                                                  "
                                                  v-b-tooltip
                                                  title="Alterar Custo"
                                                  ><i class="fa fa-edit"></i
                                                ></a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </section>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t6' + rowData.cargaId + ''"
          v-if="rowData.cargaRota !== null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 33%">Ordem do Pedágio</th>
                <th style="width: 33%">Nome</th>
                <th style="width: 33%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.cargaRota.cargaRotaPedagio"
              >
                <td>
                  {{ item.ordem }}
                </td>
                <td>
                  {{ item.nome }}
                </td>
                <td>
                  {{ item.valor }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t7' + rowData.cargaId + ''"
          v-if="rowData.despesaCargaCollection.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Descrição do Adiantamento</th>
                <th style="width: 10%">Valor</th>
                <th style="width: 10%">Status Adiantamento</th>
                <th style="width: 10%">Status Erp</th>
                <th style="width: 10%">Dt.Aprovação</th>
                <th style="width: 10%">Usuário Aprovação</th>
                <th style="width: 10%">Dt.Reprovação</th>
                <th style="width: 10%">Usuário Reprovação</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in rowData.despesaCargaCollection">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span>
                      {{ item.despesa.descr }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ item.despesa.vlr }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge badge-warning"
                      v-if= "item.statusDespesa.valor == 1"
                      >{{ item.statusDespesa.descr }}</span
                    >
                    <span
                      class="badge badge-success"
                      v-if= "item.statusDespesa.valor == 2"
                      >{{ item.statusDespesa.descr }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if= "item.statusDespesa.valor == 3"
                      >{{ item.statusDespesa.descr }}</span
                    >
                  </td>
                  <td>
                    <span 
                     v-b-tooltip
                      :title= "item.dtProcessamentoErp == null ? 'Sem registro de data'  : formatDate(item.dtProcessamentoErp)"
                      class="badge badge-warning"
                      v-if= "item.statusErp.valor == 2"
                      >{{ item.statusErp.descr }}</span
                    >
                    <span
                     v-b-tooltip
                      :title= "item.dtProcessamentoErp == null ? 'Sem registro de data'  : formatDate(item.dtProcessamentoErp)"
                      class="badge badge-success"
                      v-if= "item.statusErp.valor == 1"
                      >{{ item.statusErp.descr }}</span
                    >
                    <span
                     v-b-tooltip
                      :title= "item.dtProcessamentoErp == null ? 'Sem registro de data'  : formatDate(item.dtProcessamentoErp)"
                      class="badge badge-danger"
                      v-if= "item.statusErp.valor == 3"
                      >{{ item.statusErp.descr }}</span
                    >
                  </td>
                  <td>
                    <span v-if="item.dtAprovacao != null">
                      {{ formatDate(item.dtAprovacao) }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.usuarioAprovacao != null">
                      {{ item.usuarioAprovacao.pessoa.pessoaFisica.nome }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.dtReprovacao != null">
                      {{ formatDate(item.dtReprovacao) }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.usuarioReprocacao != null">
                      {{ item.usuarioReprocacao.pessoa.pessoaFisica.nome }}
                    </span>
                  </td>
                  <td>
                    <a
                      v-if="item.statusDespesa.valor == 1"
                      @click="onAdiantar(item)"
                      v-b-tooltip
                      title="Editar"
                      ><i class="fa fa-edit"></i
                    ></a>
                    <a v-if="getPermissionFw('gestaocarga.aprovaradiantamento') && item.statusDespesa.valor == 1"
                    @click="onApprove(item.descar_id)"
                      v-b-tooltip
                      title="Aprovar Adiantamento"
                      ><i class="fa fa-check"></i
                    ></a>
                    <a v-if="getPermissionFw('gestaocarga.reprovaradiantamento') && item.statusDespesa.valor == 1"
                      @click="onDisapprove(item.descar_id)"
                      v-b-tooltip
                      title="Reprovar Adiantamento"
                      ><i class="fa fa-times"></i
                    ></a>
                    <a v-if="getPermissionFw('gestaocarga.reenviaradiantamento') && item.statusDespesa.valor == 2 && item.statusErp.valor == 3"
                      @click="onReenvio(item.descar_id)"
                      v-b-tooltip
                      title="Reenviar ao ERP"
                      ><i class="fa fa-reply"></i
                    ></a>
                    <a
                      @click="onDetail(item.descar_id)"
                      v-b-tooltip
                      v-if="item.statusErp.valor == 3 && rowData.integracaoLog.length > 0"
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.descar_id)">
                  <td colspan="15">
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.descar_id + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th data-toggle="true" style="width: 30%">Descrição</th>
                                <th data-toggle="true" style="width: 3%">Qtde</th>
                                <th data-toggle="true" style="width: 10%">
                                  Data Primeira e Ultima Ocorrencia
                                </th>
                              </tr>
                            </thead>
                            <tbody v-for="item2 in rowData.integracaoLog">
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td v-if="item2.integracaoId == 255">
                                  <span v-if="item2.integracaoId == 255">
                                  {{ item2.descr }}
                                  </span>
                                </td>
                                <td v-if="item2.integracaoId == 255">
                                  <span v-if="item2.integracaoId == 255">
                                    {{ item2.qtde }}
                                  </span>
                                </td>
                                <td v-if="item2.integracaoId == 255">
                                  <span v-if="item2.integracaoId == 255">
                                    {{ formatDateHora(item2.dtPrimeiraOcorrencia) }}<br />
                                    {{ formatDateHora(item2.dtUltimaOcorrencia) }}
                                  </span>
                                </td>
                              </tr>
                              </tbody>
                          </table>
                        </div>
                      </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div
            role="tabpanel"
            class="tab-pane fade pt-1 border-color-detalhes-grey"
            v-bind:id="'t10' + rowData.cargaId + ''"
            v-if="rowData.erroAdiantamento != ''"
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th data-toggle="true" style="width: 100%">Descrição erro</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bg-gray-light" style="display: table-row">
              <td>
                  <span style="white-space: pre-line">{{ rowData.erroAdiantamento }}</span>
              </td>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div
            role="tabpanel"
            class="tab-pane fade pt-1 border-color-detalhes-grey"
            v-bind:id="'t11' + rowData.cargaId + ''"
            v-if="rowData.integracaoLog.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th data-toggle="true" style="width: 40%">Descrição erro</th>
              <th data-toggle="true" style="width: 25%">Data primeiro erro</th>
              <th data-toggle="true" style="width: 25%">Data ultimo erro</th>
              <th data-toggle="true" style="width: 10%">Qtde.</th>
            </tr>
            </thead>
            <tbody v-for="item in rowData.integracaoLog">
            <tr class="bg-gray-light" style="display: table-row">
              <td>
                <span style="white-space: pre-line">{{ item.descr }}</span>
              </td>
              <td>
                <span style="white-space: pre-line">{{ formatDate(item.dtPrimeiraOcorrencia) }}</span>
              </td>
              <td>
                <span style="white-space: pre-line">{{ formatDate(item.dtUltimaOcorrencia) }}</span>
              </td>
              <td>
                <span style="white-space: pre-line">{{ item.qtde }}</span>
              </td>

            </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.cargaId + ''"
          v-if="rowData.consultaCompleta"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Cod. Vale Pedagio</th>
                <th data-toggle="true" style="width: 20%">
                  Valor Vale Pedagio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span
                    v-if="
                      rowData.cargaValePedagio != null &&
                      rowData.cargaValePedagio.cdValePedagio != 0
                    "
                    >{{ rowData.cargaValePedagio.cdValePedagio }}</span
                  >
                  <span
                    v-if="
                      rowData.cargaValePedagio == null ||
                      rowData.cargaValePedagio.cdValePedagio == 0
                    "
                    >Sem dados Registrados</span
                  >
                </td>
                <td>
                  <span
                    v-if="
                      rowData.cargaValePedagio != null &&
                      rowData.cargaValePedagio.vlrValePedagio != 0
                    "
                    >{{
                      formatNumber(rowData.cargaValePedagio.vlrValePedagio)
                    }}</span
                  >
                  <span
                    v-if="
                      rowData.cargaValePedagio == null ||
                      rowData.cargaValePedagio.vlrValePedagio == 0
                    "
                    >Sem dados Registrados</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.cargaId + ''"
          v-if="rowData.redespachos.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Nome</th>
                <th style="width: 5%">CNPJ</th>
                <th style="width: 5%">Vlr. Total NF</th>
                <th style="width: 5%">Peso Bruto</th>
                <th style="width: 5%">Qtde. Nfs</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="rowData.redespachos.length > 0 &&
                  rowData.cargaBipDoc.length > 0 &&
                  (rowData.status.valor != 6 && rowData.status.valor != 3)" v-for="(item, i) in rowData.redespachos">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.nome }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.cnpj }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ formatNumber(item.vlr_total_nfs) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ formatNumber(item.peso_bruto) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.qtd_nfs }}
                    </span>
                  </td>
                  <td>
                    <a
                      @click="onDetail(item.cnpj)"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.cnpj)">
                  <td colspan="15">
                    <section class="tabs-section">
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr9' + item.carbipdocId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 5%">N. Fiscal</th>
                                <th style="width: 5%">Valor NF</th>
                                <th style="width: 5%">Dt emissão NF</th>
                                <th style="width: 5%">Dt previsão NF</th>
                                <th style="width: 5%">N° CTe</th>
                                <th style="width: 5%">Valor CTe</th>
                                <th style="width: 5%">Dt emissão CTe</th>
                                <th style="width: 5%">Processo</th>
                                <th style="width: 5%">Operação</th>
                                <th style="width: 5%">N° Pedido</th>
                                <th style="width: 5%">Unidade Carga</th>
                                <th style="width: 5%">N° carga tracking</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-if="item.notas.length > 0" v-for="(item2, i2) in item.notas">
                                <tr class="bg-gray-light" style="display: table-row">
                                  <td>
                                    <span
                                      v-b-tooltip.hover.rightbottom
                                      :title="'Chave : ' + item2.chave"
                                    >
                                      {{ item2.numFiscal }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-b-tooltip.hover.rightbottom
                                      :title="'Id trn : ' + item2.pessoaIdTrn"
                                    >
                                      {{ formatNumber(item2.docFiscalVlrTotal) }}
                                    </span>
                                  </td>
                                  <td>
                                    {{ formatDate(item2.dtEmi) }}
                                  </td>
                                  <td>
                                    {{ formatDate(item2.dtPrevisao) }}
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.cargaDoc.docCargaDoc != null && item2.cargaDoc.docCargaDoc.doc != null
                                      "
                                    >
                                      {{ item2.cargaDoc.docCargaDoc.doc.numFiscal }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.cargaDoc.docCargaDoc != null && item2.cargaDoc.docCargaDoc.doc != null
                                      "
                                    >
                                      {{ formatNumber(item2.cargaDoc.docCargaDoc.doc.vlrPrestacao) }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.cargaDoc.docCargaDoc != null && item2.cargaDoc.docCargaDoc.doc != null
                                      "
                                    >
                                      {{ formatDate(item2.cargaDoc.docCargaDoc.doc.dtEmi) }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.cargaDoc.docCargaDoc != null && item2.cargaDoc.docCargaDoc.doc != null
                                      "
                                    >
                                      {{ item2.cargaDoc.docCargaDoc.doc.tpProcesso }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.cargaDoc.docCargaDoc != null && item2.cargaDoc.docCargaDoc.doc != null
                                      "
                                    >
                                      {{ item2.cargaDoc.docCargaDoc.doc.tpOperacao }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="item2.cargaDoc.cargaDocUnidadeCarga.length > 0"
                                    >
                                      {{
                                        item2.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedido
                                          .numPedido
                                      }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="item2.cargaDoc.cargaDocUnidadeCarga.length > 0"
                                    >
                                      {{
                                        item2.cargaDoc.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.numUc
                                      }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        item2.docFiscalTracking &&
                                        rowData.tpOperacaoPrincipal.valor == 3
                                      "
                                    >
                                      {{ item2.docFiscalTracking }}
                                    </span>
                                    <span
                                      v-if="
                                        item2.manifesto != null &&
                                        rowData.tpOperacaoPrincipal.valor == 2
                                      "
                                    >
                                      {{
                                        item2.manifesto
                                          .numCargaItrack
                                      }}
                                    </span>
                                  </td>
                                  <td>
                                    <a
                                      @click="onDetail(item2.docfisId)"
                                      v-b-tooltip
                                      title="Ver detalhes"
                                      ><i class="fa fa-plus"></i
                                    ></a>
                                  </td>
                                </tr>
                                <tr v-if="isVisibleDetailRow(item2.docfisId)">
                                  <td colspan="15">
                                    <section class="tabs-section">
                                      <ul
                                        class="nav nav-tabs nav-topline nav-justified"
                                        role="tablist"
                                      >
                                        <li class="nav-item">
                                          <a
                                            class="nav-link active"
                                            v-bind:href="'#tr1' + item2.docfisId + ''"
                                            role="tab"
                                            data-toggle="tab"
                                          >
                                            <span class="nav-link-in">
                                              Partes Env.
                                              <i class="fa fa-map-marker"></i>
                                            </span>
                                          </a>
                                        </li>
                                        <li class="nav-item">
                                          <a
                                            class="nav-link"
                                            v-bind:href="'#tr2' + item2.docfisId + ''"
                                            role="tab"
                                            data-toggle="tab"
                                          >
                                            <span class="nav-link-in">
                                              Ocorrências
                                              <i class="fa fa-map-marker"></i>
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                      <div class="tab-content">
                                        <div
                                          role="tabpanel"
                                          class="
                                            tab-pane
                                            fade
                                            in
                                            active
                                            show
                                            pt-1
                                            border-color-detalhes-grey
                                          "
                                          v-bind:id="'tr1' + item2.docfisId + ''"
                                        >
                                          <table
                                            :class="[
                                              'vuetable table table-striped tbl-typical',
                                            ]"
                                          >
                                            <thead>
                                              <tr>
                                                <th style="width: 10%"></th>
                                                <th style="width: 10%">CNPJ / CPF</th>
                                                <th style="width: 10%">IE</th>
                                                <th style="width: 10%">Nome</th>
                                                <th style="width: 10%">Município</th>
                                                <th style="width: 3%">Estado</th>
                                                <th style="width: 15%">Endereço</th>
                                                <th style="width: 12%">Bairro</th>
                                                <th style="width: 10%">CEP</th>
                                                <th style="width: 10%">Email</th>
                                                <th style="width: 5%">Telefone</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv.emiEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-primary"
                                                    >Emitente</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .emiCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.emiCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.emiIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.emiNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.emiUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.emiNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.emiBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.emiCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.emiEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.emiEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .emiTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv.remEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-warning"
                                                    >Remetente</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .remCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.remCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.remIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.remNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.remUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.remNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.remBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.remCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.remEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.remEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .remTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv.expEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-info"
                                                    >Expedidor</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .expCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.expCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.expIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.expNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.expUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.expNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.expBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.expCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.expEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.expEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .expTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv.desEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-success"
                                                    >Destinatário</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .desCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.desCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.desIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.desNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.desUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.desNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.desBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.desCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.desEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.desEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .desTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                              >
                                                <td>
                                                  <span class="badge badge-secondary"
                                                    >Recebedor</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .redCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.redCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.redIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.redNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.redUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.redNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.redBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.redCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.redEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.redEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .redTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv.tomEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-primary"
                                                    >Tomador</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .tomCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv.tomCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.tomIe }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.tomNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.tomUf }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv.tomNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv.tomBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{ item2.docFiscalPartesEnv.tomCep }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv.tomEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv.tomEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .tomTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>

                                        <div
                                          role="tabpanel"
                                          class="
                                            tab-pane
                                            fade
                                            in
                                            pt-1
                                            border-color-detalhes-grey
                                          "
                                          v-bind:id="'tr2' + item2.docfisId + ''"
                                        >
                                          <table
                                            :class="[
                                              'vuetable table table-striped tbl-typical',
                                            ]"
                                          >
                                            <thead>
                                              <tr>
                                                <th style="width: 10%">Tipo</th>
                                                <th style="width: 10%">Ocorrência</th>
                                                <th style="width: 10%">Data Ocorrência</th>
                                                <th style="width: 10%">N ° Docmento</th>
                                                <th style="width: 10%">Série</th>
                                                <th style="width: 10%">Dt Emissão</th>
                                                <th style="width: 10%">N ° Fiscal</th>
                                                <th style="width: 10%">Série</th>
                                                <th style="width: 10%">Dt Emissão</th>
                                                <th style="width: 10%">Status</th>
                                              </tr>
                                            </thead>
                                            <tbody
                                              v-for="item_ocorrencia in item2.cargaOcorrencia"
                                            >
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                              >
                                                <td>
                                                  <span
                                                    v-if="item_ocorrencia.docfisId !== null"
                                                    class="badge badge-primary"
                                                    >Documento</span
                                                  >
                                                  <span
                                                    v-if="item_ocorrencia.pedunicarId !== null"
                                                    class="badge badge-warning"
                                                    >Unidade Carga</span
                                                  >
                                                  <span
                                                    v-if="item_ocorrencia.peduncatrId !== null"
                                                    class="badge badge-danger"
                                                    >Trecho</span
                                                  >
                                                </td>
                                                <td>
                                                  {{ item_ocorrencia.paramOcorrencia.descr }}
                                                </td>
                                                <td>
                                                  {{ formatDate(item_ocorrencia.dtOcorrencia) }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="item_ocorrencia.docNumFiscal != null"
                                                  >
                                                    {{ item_ocorrencia.docNumFiscal }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span v-if="item_ocorrencia.docSerie != null">
                                                    {{ item_ocorrencia.docSerie }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span v-if="item_ocorrencia.docDtEmi != null">
                                                    {{ formatDate(item_ocorrencia.docDtEmi) }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docFiscalNumFiscal != null
                                                    "
                                                  >
                                                    {{ item_ocorrencia.docFiscalNumFiscal }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span v-if="item_ocorrencia.docSerie != null">
                                                    {{ item_ocorrencia.docSerie }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docFiscalDtEmi != null
                                                    "
                                                  >
                                                    {{
                                                      formatDate(item_ocorrencia.docFiscalDtEmi)
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    class="badge badge-success"
                                                    v-if="item_ocorrencia.status.valor == 1"
                                                    >{{ item_ocorrencia.status.descr }}</span
                                                  >
                                                  <span
                                                    class="badge badge-danger"
                                                    v-if="item_ocorrencia.status.valor == 2"
                                                    >{{ item_ocorrencia.status.descr }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </section>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
              <template v-if="rowData.redespachos.length > 0 &&
                  rowData.cargaDoc.length > 0 && (rowData.status.valor == 6 || rowData.status.valor == 3)" v-for="(item, i) in rowData.redespachos">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.nome }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.cnpj }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ formatNumber(item.vlr_total_nfs) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ formatNumber(item.peso_bruto) }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-b-tooltip.hover.rightbottom
                    >
                      {{ item.qtd_nfs }}
                    </span>
                  </td>
                  <td>
                    <a
                      @click="onDetail(item.cnpj)"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.cnpj)">
                  <td colspan="9">
                    <section class="tabs-section">                      
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show"
                        v-bind:id="'t9' + rowData.cargaId + ''"
                      >
                        <table class="table" id="mais">
                          <thead>
                            <tr>
                              <th style="width: 5%">N. Fiscal</th>
                              <th style="width: 5%">Valor NF</th>
                              <th style="width: 5%">Dt emissão NF</th>
                              <th style="width: 5%">Dt previsão NF</th>
                              <th style="width: 5%">N° CTe</th>
                              <th style="width: 5%">Valor CTe</th>
                              <th style="width: 5%">Dt emissão CTe</th>
                              <th style="width: 5%">Processo</th>
                              <th style="width: 5%">Operação</th>
                              <th style="width: 5%">N° Pedido</th>
                              <th style="width: 5%">Unidade Carga</th>
                              <th style="width: 5%">N° carga tracking</th>
                              <th style="width: 5%">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(item2, i2) in item.notas">
                              <tr class="bg-gray-light" style="display: table-row">
                                <td>
                                  <span
                                    v-b-tooltip.hover.rightbottom
                                    :title="'Chave : ' + item2.docFiscal.chave"
                                  >
                                    {{ item2.docFiscal.numFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-b-tooltip.hover.rightbottom
                                    :title="'Id trn : ' + item2.docFiscal.pessoaIdTrn"
                                  >
                                    {{ formatNumber(item2.docFiscal.docFiscalVlrTotal) }}
                                  </span>
                                </td>
                                <td>
                                  {{ formatDate(item2.docFiscal.dtEmi) }}
                                </td>
                                <td>
                                  {{ formatDate(item2.docFiscal.dtPrevisao) }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docCargaDoc != null && item2.docCargaDoc.doc != null
                                    "
                                  >
                                    {{ item2.docCargaDoc.doc.numFiscal }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docCargaDoc != null && item2.docCargaDoc.doc != null
                                    "
                                  >
                                    {{ formatNumber(item2.docCargaDoc.doc.vlrPrestacao) }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docCargaDoc != null && item2.docCargaDoc.doc != null
                                    "
                                  >
                                    {{ formatDate(item2.docCargaDoc.doc.dtEmi) }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docCargaDoc != null && item2.docCargaDoc.doc != null
                                    "
                                  >
                                    {{ item2.docCargaDoc.doc.tpProcesso }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docCargaDoc != null && item2.docCargaDoc.doc != null
                                    "
                                  >
                                    {{ item2.docCargaDoc.doc.tpOperacao }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="rowData.cargaDoc[0].cargaDocUnidadeCarga.length > 0"
                                  >
                                    {{
                                      item2.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.pedido
                                        .numPedido
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="rowData.cargaDoc[0].cargaDocUnidadeCarga.length > 0"
                                  >
                                    {{
                                      item2.cargaDocUnidadeCarga[0].pedidoUnidadeCarga.numUc
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item2.docFiscalTracking &&
                                      rowData.tpOperacaoPrincipal.valor == 3
                                    "
                                  >
                                    {{ item2.docFiscalTracking }}
                                  </span>
                                  <span
                                    v-if="
                                      item2.manifesto != null &&
                                      rowData.tpOperacaoPrincipal.valor == 2
                                    "
                                  >
                                    {{
                                      item2.manifesto
                                        .numCargaItrack
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <a
                                    @click="onDetail(item2.cardocId)"
                                    v-b-tooltip
                                    title="Ver detalhes"
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                </td>
                              </tr>
                              <tr v-if="isVisibleDetailRow(item2.cardocId)">
                                <td colspan="15">
                                  <section class="tabs-section">
                                    <ul
                                      class="nav nav-tabs nav-topline nav-justified"
                                      role="tablist"
                                    >
                                      <li class="nav-item">
                                        <a
                                          class="nav-link active"
                                          v-bind:href="'#tr1' + item2.cardocId + ''"
                                          role="tab"
                                          data-toggle="tab"
                                        >
                                          <span class="nav-link-in">
                                            Partes Env.
                                            <i class="fa fa-map-marker"></i>
                                          </span>
                                        </a>
                                      </li>
                                      <li class="nav-item">
                                        <a
                                          class="nav-link"
                                          v-bind:href="'#tr2' + item2.cardocId + ''"
                                          role="tab"
                                          data-toggle="tab"
                                        >
                                          <span class="nav-link-in">
                                            Ocorrências
                                            <i class="fa fa-map-marker"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                    <div class="tab-content">
                                      <div
                                        role="tabpanel"
                                        class="
                                          tab-pane
                                          fade
                                          in
                                          active
                                          show
                                          pt-1
                                          border-color-detalhes-grey
                                        "
                                        v-bind:id="'tr1' + item2.cardocId + ''"
                                      >
                                        <table
                                          :class="[
                                            'vuetable table table-striped tbl-typical',
                                          ]"
                                        >
                                          <thead>
                                            <tr>
                                              <th style="width: 10%"></th>
                                              <th style="width: 10%">CNPJ / CPF</th>
                                              <th style="width: 10%">IE</th>
                                              <th style="width: 10%">Nome</th>
                                              <th style="width: 10%">Município</th>
                                              <th style="width: 3%">Estado</th>
                                              <th style="width: 15%">Endereço</th>
                                              <th style="width: 12%">Bairro</th>
                                              <th style="width: 10%">CEP</th>
                                              <th style="width: 10%">Email</th>
                                              <th style="width: 5%">Telefone</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                              v-if="
                                                item2.docFiscal.docFiscalPartesEnv.emiEndereco
                                              "
                                            >
                                              <td>
                                                <span class="badge badge-primary"
                                                  >Emitente</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .emiCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .emiCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .emiCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.emiCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.emiIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.emiNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .emiNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.emiUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .emiEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .emiComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.emiNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.emiBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.emiCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.emiEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.emiEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .emiTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .emiTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>

                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                              v-if="
                                                item2.docFiscal.docFiscalPartesEnv.remEndereco
                                              "
                                            >
                                              <td>
                                                <span class="badge badge-warning"
                                                  >Remetente</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .remCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .remCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .remCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.remCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.remIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.remNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .remNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.remUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .remEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .remComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.remNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.remBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.remCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.remEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.remEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .remTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .remTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>

                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                              v-if="
                                                item2.docFiscal.docFiscalPartesEnv.expEndereco
                                              "
                                            >
                                              <td>
                                                <span class="badge badge-info"
                                                  >Expedidor</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .expCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .expCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .expCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.expCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.expIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.expNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .expNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.expUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .expEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .expComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.expNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.expBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.expCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.expEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.expEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .expTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .expTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>

                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                              v-if="
                                                item2.docFiscal.docFiscalPartesEnv.desEndereco
                                              "
                                            >
                                              <td>
                                                <span class="badge badge-success"
                                                  >Destinatário</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .desCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .desCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .desCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.desCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.desIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.desNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .desNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.desUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .desEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .desComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.desNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.desBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.desCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.desEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.desEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .desTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .desTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>

                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                            >
                                              <td>
                                                <span class="badge badge-secondary"
                                                  >Recebedor</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .redCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .redCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .redCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.redCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.redIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.redNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .redNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.redUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .redEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .redComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.redNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.redBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.redCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.redEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.redEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .redTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .redTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>

                                          <tbody>
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                              v-if="
                                                item2.docFiscal.docFiscalPartesEnv.tomEndereco
                                              "
                                            >
                                              <td>
                                                <span class="badge badge-primary"
                                                  >Tomador</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .tomCnpj != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv
                                                        .tomCnpj
                                                    )
                                                  }}
                                                </span>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .tomCpf != null
                                                  "
                                                >
                                                  {{
                                                    ajustaMascara(
                                                      item2.docFiscal.docFiscalPartesEnv.tomCpf
                                                    )
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.tomIe }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.tomNome
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .tomNomeMunicipio
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.tomUf }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .tomEndereco
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv
                                                    .tomComplemento
                                                }}
                                                -
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.tomNumero
                                                }}
                                              </td>
                                              <td>
                                                {{
                                                  item2.docFiscal.docFiscalPartesEnv.tomBairro
                                                }}
                                              </td>
                                              <td>
                                                {{ item2.docFiscal.docFiscalPartesEnv.tomCep }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv.tomEmail
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv.tomEmail
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .tomTelefone
                                                  "
                                                  >{{
                                                    item2.docFiscal.docFiscalPartesEnv
                                                      .tomTelefone
                                                  }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>

                                      <div
                                        role="tabpanel"
                                        class="
                                          tab-pane
                                          fade
                                          in
                                          pt-1
                                          border-color-detalhes-grey
                                        "
                                        v-bind:id="'tr2' + item2.cardocId + ''"
                                      >
                                        <table
                                          :class="[
                                            'vuetable table table-striped tbl-typical',
                                          ]"
                                        >
                                          <thead>
                                            <tr>
                                              <th style="width: 10%">Tipo</th>
                                              <th style="width: 10%">Ocorrência</th>
                                              <th style="width: 10%">Data Ocorrência</th>
                                              <th style="width: 10%">N ° Docmento</th>
                                              <th style="width: 10%">Série</th>
                                              <th style="width: 10%">Dt Emissão</th>
                                              <th style="width: 10%">N ° Fiscal</th>
                                              <th style="width: 10%">Série</th>
                                              <th style="width: 10%">Dt Emissão</th>
                                              <th style="width: 10%">Status</th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            v-for="item_ocorrencia in item2.docFiscal
                                              .cargaOcorrencia"
                                          >
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                            >
                                              <td>
                                                <span
                                                  v-if="item_ocorrencia.docfisId !== null"
                                                  class="badge badge-primary"
                                                  >Documento</span
                                                >
                                                <span
                                                  v-if="item_ocorrencia.pedunicarId !== null"
                                                  class="badge badge-warning"
                                                  >Unidade Carga</span
                                                >
                                                <span
                                                  v-if="item_ocorrencia.peduncatrId !== null"
                                                  class="badge badge-danger"
                                                  >Trecho</span
                                                >
                                              </td>
                                              <td>
                                                {{ item_ocorrencia.paramOcorrencia.descr }}
                                              </td>
                                              <td>
                                                {{ formatDate(item_ocorrencia.dtOcorrencia) }}
                                              </td>
                                              <td>
                                                <span
                                                  v-if="item_ocorrencia.docNumFiscal != null"
                                                >
                                                  {{ item_ocorrencia.docNumFiscal }}
                                                </span>
                                              </td>
                                              <td>
                                                <span v-if="item_ocorrencia.docSerie != null">
                                                  {{ item_ocorrencia.docSerie }}
                                                </span>
                                              </td>
                                              <td>
                                                <span v-if="item_ocorrencia.docDtEmi != null">
                                                  {{ formatDate(item_ocorrencia.docDtEmi) }}
                                                </span>
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item_ocorrencia.docFiscalNumFiscal != null
                                                  "
                                                >
                                                  {{ item_ocorrencia.docFiscalNumFiscal }}
                                                </span>
                                              </td>
                                              <td>
                                                <span v-if="item_ocorrencia.docSerie != null">
                                                  {{ item_ocorrencia.docSerie }}
                                                </span>
                                              </td>
                                              <td>
                                                <span
                                                  v-if="
                                                    item_ocorrencia.docFiscalDtEmi != null
                                                  "
                                                >
                                                  {{
                                                    formatDate(item_ocorrencia.docFiscalDtEmi)
                                                  }}
                                                </span>
                                              </td>
                                              <td>
                                                <span
                                                  class="badge badge-success"
                                                  v-if="item_ocorrencia.status.valor == 1"
                                                  >{{ item_ocorrencia.status.descr }}</span
                                                >
                                                <span
                                                  class="badge badge-danger"
                                                  v-if="item_ocorrencia.status.valor == 2"
                                                  >{{ item_ocorrencia.status.descr }}</span
                                                >
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </section>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <!--.tab-content-->
      <GerenciamentoTransporteAdiantamento
        ref="gerenciamentotransporteadiantamento"
      />
      <UnidadeCargaTrechoForm ref="unidadecargatrechoform" />
      <GestaoCargaUnidadeCargaTrechoForm ref="gestaocargaunidadecargatrechoform" />
      <PedidoTabelaFreteModal ref="pedidotabelafretemodal" />
    </div>
  </div>
</template>

  <script>
import accounting from "accounting";
import moment from "moment";
import GerenciamentoTransporteAdiantamento from "./GerenciamentoTransporteAdiantamento.vue";
import UnidadeCargaTrechoForm from "./UnidadeCargaTrechoForm.vue";
import GestaoCargaUnidadeCargaTrechoForm from "./GestaoCargaUnidadeCargaTrechoForm.vue";
import PedidoTabelaFreteModal from "./PedidoTabelaFreteModal.vue";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    GerenciamentoTransporteAdiantamento,
    UnidadeCargaTrechoForm,
    GestaoCargaUnidadeCargaTrechoForm,
    PedidoTabelaFreteModal,
  },
  data() {
    return {
      visibleDetailRowsTrecho: [],
      visibleDetailRows: [],
      visibleDetailRowsTrechoCusto: [],
      form: new Form({
        trecho: [],
        pedunicar_id: "",
        descar_id: ""
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onAdiantar(data) {
      this.$refs.gerenciamentotransporteadiantamento.onEdit(data);
    },
    onApprove(id) {
      this.loading = true;
      this.isDisabled = true;      
      this.form.descar_id = id;

      this.form
        .patch("/api/gestaocarga/aprovaradiantamento")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
          console.log("ERRO");
        });
    },
    onDisapprove(id) {
      this.loading = true;
      this.isDisabled = true;      
      this.form.descar_id = id;

      this.form
        .patch("/api/gestaocarga/reprovaradiantamento")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
          console.log("ERRO");
        });
    },
    onReenvio(id) {
      this.loading = true;
      this.isDisabled = true;      
      this.form.descar_id = id;

      this.form
        .patch("/api/gestaocarga/reenviaradiantamento")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
          console.log("ERRO");
        });
    },
    onDetailUnidadeCargaTrecho(pedunicar_id) {
      this.toggleDetailRowTrecho(pedunicar_id);
    },

    isVisibleDetailRowTrecho(rowId) {
      return this.visibleDetailRowsTrecho.indexOf(rowId) >= 0;
    },
    showDetailRowTrecho(rowId) {
      if (!this.isVisibleDetailRowTrecho(rowId)) {
        this.visibleDetailRowsTrecho.push(rowId);
      }
    },
    hideDetailRowTrecho(rowId) {
      if (this.isVisibleDetailRowTrecho(rowId)) {
        this.visibleDetailRowsTrecho.splice(
          this.visibleDetailRowsTrecho.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowTrecho(rowId) {
      if (this.isVisibleDetailRowTrecho(rowId)) {
        this.hideDetailRowTrecho(rowId);
      } else {
        this.showDetailRowTrecho(rowId);
      }
    },
    //
    onDetail(cardoc_id) {
      this.toggleDetailRow(cardoc_id);
    },
    onVinculaTrecho(data) {
      let form = this.form;
      let pedunicar_id = data.pedunicarId;
      var vm = this;
      const onConfirmWrapper = () => {
        confirmFn(vm);
      };
      const onCloseWrapper = () => {
        vm.$refs.gestaocargaunidadecargatrechoform.onCreate(data, 1);
      };

      let confirmFn = function (vm) {

        vm.form.pedunicar_id= pedunicar_id
        vm.form
          .post("/api/gestaocarga/buscatrecho/"+pedunicar_id)
          .then((response) => {
            new ReturnApi(response, vm, null, null, false);
             vm.$refs.gestaocargaunidadecargatrechoform.onCreate(response, 2);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };

      let obj = {
        title: "Você deseja utilizar dados do trecho anterior ?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmWrapper,
        onClose: onCloseWrapper,
      };

      this.$Simplert.open(obj);

      /*
            let dados = data;
            let form = this.form;


            let swal = this.$swal;
            let ref = this.$refs;
            this.$swal({
                  title: 'Você deseja encerrar o MDFE ?',
                  text: "Esta ação é irreversível",
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Sim, encerrar!',
                  cancelButtonText: 'Não',
                }).then(function () {
                    $(this).loading = true;
                    $(this).isDisabled = true;

                }, function (dismiss) {
                        // Cancel
                });
                */
    },
    isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    /////////////////////////////////////////////////////////
    onDetailUnidadeCargaTrechoCusto(peuncatrcu_id) {
      this.toggleDetailRowTrechoCusto(peuncatrcu_id);
    },
    isVisibleDetailRowTrechoCusto(rowId) {
      return this.visibleDetailRowsTrechoCusto.indexOf(rowId) >= 0;
    },
    showDetailRowTrechoCusto(rowId) {
      if (!this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.visibleDetailRowsTrechoCusto.push(rowId);
      }
    },
    hideDetailRowTrechoCusto(rowId) {
      if (this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.visibleDetailRowsTrechoCusto.splice(
          this.visibleDetailRowsTrechoCusto.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowTrechoCusto(rowId) {
      if (this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.hideDetailRowTrechoCusto(rowId);
      } else {
        this.showDetailRowTrechoCusto(rowId);
      }
    },
    onAlteraFornecedor(data) {
      this.$refs.unidadecargacustoform.onCreate(data);
    },
    onAlteraStatus(data) {
      this.$refs.gestaocargaunidadecargatrechoform.onCreate(data);
    },
    onVinculaCusto(data) {
      this.$refs.unidadecargacustoform.onCreate(data);
    },
    onPrintMinuta(data) {
      this.form.trecho = [];
      this.form.trecho.push(data.peduncatrId);
      this.form
        .post("/api/gestaocarga/calculo/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
        });
    },
    onEditCusto(data) {
      this.$refs.unidadecargacustoform.onEdit(data);
    },
    onEditTrecho(data) {
      this.$refs.gestaocargaunidadecargatrechoform.onEdit(data);
    },
    onCalcularTrecho(data) {
      this.$refs.unidadecargatrechoform.onCalcular(data);
    },
    onVinculaOcorrencia(data, tipo) {
      this.$refs.cargaocorrenciaform.onCreate(data, tipo);
    },
    ///////////////////////////////////////////////////////
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    viewTabelaFrete(tabfrerotvig_id) {
      this.$refs.pedidotabelafretemodal.getData(tabfrerotvig_id);
      this.$refs.pedidotabelafretemodal.onView();
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  },
};
</script>